import axios from "axios";
import { GetAllCategoryDTO } from "../../dto";
import { plainToClass } from "class-transformer";
import { validate } from "class-validator";

type GetAllCategoryProps = {
  page: number;
  pageSize: number;
  title?: string;
  titleOrder?: "ASC" | "DESC" | "";
};

let body: GetAllCategoryDTO;

export async function getAllCategoryAction(props: GetAllCategoryProps) {
  const token = localStorage.getItem("token");

  const params = {
    page: props.page,
    pageSize: props.pageSize,
    title: props.title,
    titleOrder: props.titleOrder !== "" ? props.titleOrder : undefined,
  };

  return await axios
    .get(`${process.env.REACT_APP_API_ORIGIN}/1.0.0/cms/categories/get-all`, {
      headers: {
        "Content-Type": "application/json",
        "app-platform": "cms",
        Authorization: `Bearer ${token}`,
      },
      params,
    })
    .then(async (res) => {
      body = plainToClass(GetAllCategoryDTO, res.data);
      const errors = await validate(body);

      if (errors.length > 0) {
        throw errors;
      }

      return res.data;
    });
}
